module.exports = __webpack_public_path__ + "static/media/F.75a22fcb.png";